'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { ProductCardSummary } from '@/components/atomic/molecules';
import { NO_PRODUCT_IMAGE, staticMediaStoreBaseURL } from '@/config/common';
import { getImageURL } from '@/helpers/carousel';
import { useIsMobile } from '@/lib/screenResolution';
import { getAuthIdentity } from '@/services/identity.service';
import { getPageURL, PAGE_NAME } from '@/services/partnerPortal.service';

const ProductImage = ({
  imageClassName = 'rounded-t-xl object-fit-cover',
  imageContainerClassName = '',
  item: { productMedia }
}) => {
  const [media] = productMedia || [];

  const { media: { source, url } = {} } = media || {};

  const [imageURL, setImageURL] = useState(getImageURL({ source, url }));

  return (
    <div className='product-image clickable'>
      <div className={`relative ${imageContainerClassName}`}>
        <Image
          {...{
            alt: 'item.product.name',
            className: imageClassName,
            fill: true,
            onError: () =>
              setImageURL(`${staticMediaStoreBaseURL}${NO_PRODUCT_IMAGE.url}`),
            priority: true,
            sizes: '(max-width: 600px) 100vw, 50vw',
            src: imageURL
          }}
        />
      </div>
    </div>
  );
};

const ProductCardHeader = ({ hit }) => {
  const [isMobile] = useIsMobile();
  return (
    <div>
      <div className='display-row'>
        <ProductImage
          {...{
            imageContainerClassName: 'w-full h-56 relative',
            imageClassName: `object-fit-cover rounded-xl ${isMobile ? 'rounded-t-xl' : ''}`,
            item: { ...hit }
          }}
        />
      </div>
    </div>
  );
};

const ProductCardDetail = ({
  hit,
  maxInventory,
  name,
  shortDescription,
  unitPartnerPrice
}) => (
  <div>
    <ProductCardHeader {...{ hit }} />
    <ProductCardSummary
      {...{
        maxInventory,
        name,
        shortDescription,
        unitPartnerPrice
      }}
    />
  </div>
);

const ProductCard = ({ hit }) => {
  const router = useRouter();

  const { name, productPartners = [], shortDescription, slug } = hit;
  const { partnerOrgId } = getAuthIdentity();

  const { unitPartnerPrice, maxInventory } = productPartners.find(
    ({ partnerId }) => partnerId === partnerOrgId
  );

  return (
    <div
      className='flex flex-col relative border cursor-pointer w-80 rounded-[12px] hover:border-brand hover:shadow-md'
      onClick={() =>
        router.push(
          getPageURL({
            pageName: PAGE_NAME.PRODUCT_DETAIL.label,
            pathParams: { productSlug: slug }
          })
        )
      }
    >
      <ProductCardDetail
        {...{
          hit,
          maxInventory,
          name,
          shortDescription,
          unitPartnerPrice
        }}
      />
    </div>
  );
};

export default ProductCard;
